import { Images } from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class MeteorCounter extends Phaser.GameObjects.Container {
  constructor(game) {
    super(game, 200, 61);
    this.game = game;

    this.meteorBackground = Images.addImage(0, 0, 'spaceRock', this);
    this.meteorBackground.setOrigin(.5);

    this.countText = this.game.add.bitmapText(0, -4, 'Nasalization', '0', 40);
    this.countText.setOrigin(.5);
    this.countText.tint = 0x082c2c;

    this.add(this.countText);
  }

  SetCount(count) {
    this.countText.text = count;
  }
}